import { render, staticRenderFns } from "./GoalDetail.vue?vue&type=template&id=b35b968a&scoped=true"
import script from "./GoalDetail.vue?vue&type=script&lang=js"
export * from "./GoalDetail.vue?vue&type=script&lang=js"
import style0 from "./GoalDetail.vue?vue&type=style&index=0&id=b35b968a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35b968a",
  null
  
)

export default component.exports